var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StaffList',{attrs:{"heading":"School Staff Directory","loading":_vm.$store.getters.loading,"staffList":_vm.list}})}
var staticRenderFns = []

export { render, staticRenderFns }